<template>
  <BasePopup
    :show="show"
    @close="$emit('close')"
    close-test-id="vcl-close"
    card-class="w-full md:w-[440px] lg:p-8 lg:pt-6 p-6 pt-4 flex flex-col nap-login-screen"
  >
    <!-- Header -->
    <div class="flex items-center justify-between lg:mb-2 mb-4 border-none lg:border-b pb-3">
      <h2 class="text-xl font-semibold text-black">Accedi per continuare</h2>
    </div>

    <div class="flex flex-col justify-between flex-1">
      <form @submit.prevent="submit" class="space-y-4">
        <!-- Email (read-only: it came from the intro gate) -->
        <div>
          <label class="block text-sm font-medium text-gray-500 mb-1">Email</label>
          <input
            type="email"
            data-testid="vcl-email"
            :value="emailLocal"
            readonly
            class="ic-field__input"
            style="background: #f9fafb; color: #6b7280;"
          />
        </div>

        <!-- Password -->
        <div class="relative">
          <label class="block text-sm font-medium text-gray-500 mb-1">Password</label>
          <div class="relative flex flex-row">
            <input
              :type="showPassword ? 'text' : 'password'"
              data-testid="vcl-password"
              v-model="password"
              @copy="copyPasswordSelection"
              @input="serverErrorVisible = false"
              placeholder="Inserisci la password"
              class="ic-field__input"
              style="padding-right: 2.75rem;"
            />
            <button
              type="button"
              data-testid="vcl-toggle-password"
              :aria-label="showPassword ? 'Nascondi password' : 'Mostra password'"
              :aria-pressed="showPassword"
              tabindex="-1"
              class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 focus:outline-none"
              @click="showPassword = !showPassword"
            >
              <EyeOff v-if="showPassword" class="w-5 h-5" />
              <Eye v-else class="w-5 h-5" />
            </button>
          </div>
          <!-- #857: the way out of "Email o password non corretti." -->
          <forgot-password-link class="mt-2" :email="emailLocal" />
        </div>

        <!-- Submit -->
        <div class="flex items-center w-full justify-center">
          <button
            type="button"
            data-testid="vcl-submit"
            :disabled="loading"
            class="bg-primary text-white py-3 px-8 pr-5 rounded-full font-semibold hover:bg-green-600 transition-colors duration-200 disabled:opacity-60"
            @click="submit"
          >
            <div class="flex flex-row justify-center items-center relative">
              {{ loading ? "Attendere..." : "Accedi e continua" }}
              <img v-if="!loading" :src="require('@/assets/img/icons/arrow.svg')" alt="" class="w-5 h-5 p-1 flyout-icon-white ml-2" />
            </div>
          </button>
        </div>

        <p v-if="displayError" data-testid="vcl-error" class="text-center text-red-500 text-sm">{{ displayError }}</p>
      </form>
    </div>
  </BasePopup>
</template>

<script>
import { Eye, EyeOff } from "lucide-vue-next";
import { copyPasswordSelection } from '@/utils/passwordCopy.js';
import BasePopup from "@/components/BasePopup.vue";
import ForgotPasswordLink from "@/components/ForgotPasswordLink.vue";

export default {
  name: "VideocallLoginPopup",
  components: { Eye, EyeOff, BasePopup, ForgotPasswordLink },
  props: {
    show: { type: Boolean, default: false },
    email: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    serverError: { type: String, default: "" },
  },
  emits: ["close", "login"],
  computed: {
    emailLocal() {
      return this.email;
    },
    displayError() {
      if (this.errorMsg) return this.errorMsg;
      return this.serverErrorVisible ? this.serverError : "";
    },
  },
  data() {
    return {
      password: "",
      showPassword: false,
      errorMsg: "",
      serverErrorVisible: false,
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.password = "";
        this.errorMsg = "";
        this.serverErrorVisible = false;
      }
    },
    serverError(val) {
      // A fresh server-side error should surface again.
      this.serverErrorVisible = !!val;
    },
  },
  methods: {
    copyPasswordSelection,
    submit() {
      if (this.loading) return;
      this.errorMsg = "";
      const email = (this.email || "").trim().toLowerCase();
      const password = this.password;
      if (!password) {
        this.errorMsg = "Inserisci la password.";
        return;
      }
      this.serverErrorVisible = true;
      this.$emit("login", { email, password });
    },
  },
};
</script>
